import { React, useState, useEffect } from 'react'
import axios from 'axios';
import ModalBooked from './ModalBooked';
import Modal2Booked from './Modal2Booked';
import { TiTick } from "react-icons/ti";
import { ImCross } from "react-icons/im";
import { FaEdit } from "react-icons/fa";
import { FaEye } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Loader from '../../Global/Loader';
// import { navigate } from '@reach/router';
function Booked({ consultations = [], consultants = [], fetchConsultants,
  fetchConsultations }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedConsultation, setSelectedConsultation] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingConsultation, setEditingConsultation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [isSubmitted, setIsSubmitted] = useState(false);



  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setEditingConsultation(null);
  };

  const openModal = (consultation) => {
    setSelectedConsultation(consultation);
    setIsModalOpen(true);
  }

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedConsultation(null);
  }


  const openEditModal = (consultation) => {
    setEditingConsultation(consultation);
    setIsEditModalOpen(true);
  };

  const handleApprove = async (e, consultation) => {
    e.stopPropagation(); // Prevent row click

    try {
      setLoading(true)
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/consultation/${consultation._id}/update`,
        {
          approved: true,
          rejected: false,
          status: 'Approved'
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          }
        },
      );
      fetchConsultants()
      fetchConsultations()
      setIsSubmitted(true);

    } catch (error) {
      setError(true)
    } finally {
      setLoading(false);
    }
  };

  const handleReject = async (e, consultation) => {
    e.stopPropagation(); // Prevent row click

    try {
      setLoading(true);
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/consultation/${consultation._id}/update`,
        {
          approved: false,
          rejected: true,
          status: 'Rejected'
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          }
        },
      );
      fetchConsultants()
      fetchConsultations()
      setIsSubmitted(true);

    } catch (error) {
      // console.error('Error rejecting consultation:', error);
      alert(error.response?.data?.message || 'Failed to reject consultation');
    } finally {
      setLoading(false);
    }
  };




  return (
    <>
      {loading && <Loader />}
      {
        isSubmitted && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white w-full max-w-md mx-auto rounded-lg shadow-lg p-6">
              {/* Modal Content */}
              <h2 className="text-lg font-semibold text-gray-800 mb-4">
                Success!
              </h2>
              <h4 className="text-sm text-gray-600 mb-6">
                Your application has been submitted successfully.
              </h4>
              <div className="flex justify-end space-x-4">
                {/* Proceed Button */}
                <button
                  onClick={() => {
                    setIsSubmitted(false);

                  }}
                  className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
                >
                  Okay
                </button>
              </div>
            </div>
          </div>
        )
      }

      {
        error && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white w-full max-w-md mx-auto rounded-lg shadow-lg p-6">
              {/* Modal Content */}
              <h2 className="text-lg font-semibold text-gray-800 mb-4">
                Something went wrong!
              </h2>
              <h4 className="text-sm text-gray-600 mb-6">
                We encountered an issue while processing your request. Please try again later. If the problem persists, contact support.
              </h4>
              <div className="flex justify-end space-x-4">
                {/* Proceed Button */}
                <button
                  onClick={() => setError(null)}
                  className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
                >
                  Okay
                </button>
              </div>
            </div>
          </div>
        )
      }
      <div className="flex flex-wrap space-x-6">
        <div className="flex flex-col space-y-6 w-full">

          {/* Conducted Consultations Table */}
          <div className="px-10 py-6 bg-white rounded">
            <h3 className="text-lg font-medium mb-4 text-gray-700">Conducted Consultations</h3>
            <table className="w-full table-auto border-t border-b border-gray-300">
              <thead>
                <tr className="border-b border-gray-300">
                  <th className="px-4 py-2 text-center text-gray-400">Consultation ID</th>
                  <th className="px-4 py-2 text-center text-gray-400">Name</th>
                  <th className="px-4 py-2 text-center text-gray-400">Email</th>
                  <th className="px-4 py-2 text-center text-gray-400">Cell Phone</th>
                  <th className="px-4 py-2 text-center text-gray-400">Consultant</th>
                  <th className="px-4 py-2 text-center text-gray-400">Actions</th>
                </tr>
              </thead>
              <tbody>
                {consultations.filter((consultation) => consultation.isConducted).length > 0 ?
                  consultations
                    .filter(consultation => consultation.isConducted)
                    .map((consultation) => (
                      <tr
                        key={consultation.consultationId}
                        className="border-b border-gray-300 cursor-pointer text-center"
                      >
                        <td className="px-4 py-4 text-sm text-gray-700">{consultation.consultationId}</td>
                        <td className="px-4 py-4 text-sm text-gray-700">{consultation.studentName}</td>
                        <td className="px-4 py-4 text-sm text-gray-700">{consultation.email}</td>
                        <td className="px-4 py-4 text-sm text-gray-700">{consultation.cellPhone}</td>
                        <td className="px-4 py-4 text-sm text-gray-700">{consultation.consultantName}</td>
                        <td className="px-4 py-4 text-sm font-thin">
                          <div className="flex items-center justify-center space-x-2">
                            <TiTick
                              className="text-green-500 hover:bg-green-50 rounded-full transition-colors cursor-pointer size-6"
                              onClick={(e) => handleApprove(e, consultation)}
                            />
                            <ImCross
                              className="text-red-500 hover:bg-red-50 rounded-full transition-colors cursor-pointer size-4"
                              onClick={(e) => handleReject(e, consultation)}
                            />
                            <button
                              onClick={() => openModal(consultation)}
                              className="p-2 text-blue-600 hover:bg-blue-50 rounded-full transition-colors"
                              title="Save"
                            >
                              <FaEye className="size-4" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    )) : <tr>
                    <td colSpan="6" className="px-4 py-4 text-sm text-gray-700 text-center">
                      No data available
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>


          {/* Ongoing Consultations Table */}
          <div className="px-10 py-6 bg-white rounded">
            <h3 className="text-lg font-medium mb-4 text-gray-700">Ongoing Consultations</h3>
            <table className="w-full table-auto border-t border-b border-gray-300">
              <thead>
                <tr className="border-b border-gray-300">
                  <th className="px-4 py-2 text-center text-gray-400">Consultation ID</th>
                  <th className="px-4 py-2 text-center text-gray-400">Name</th>
                  <th className="px-4 py-2 text-center text-gray-400">Email</th>
                  <th className="px-4 py-2 text-center text-gray-400">Cell Phone</th>
                  <th className="px-4 py-2 text-center text-gray-400">Consultant</th>
                  <th className="px-4 py-2 text-center text-gray-400">Action</th>
                </tr>
              </thead>
              <tbody>
                {consultations.filter((consultation) => !consultation.isConducted).length > 0 ?
                  consultations
                    .filter(consultation => !consultation.isConducted)
                    .map((consultation) => (
                      <tr
                        key={consultation.consultationId}

                        className="border-b border-gray-300 cursor-pointer text-center hover:bg-gray-50"
                      >
                        <td className="px-4 py-4 text-sm text-gray-700">{consultation.consultationId}</td>
                        <td className="px-4 py-4 text-sm text-gray-700">{consultation.studentName}</td>
                        <td className="px-4 py-4 text-sm text-gray-700">{consultation.email}</td>
                        <td className="px-4 py-4 text-sm text-gray-700">{consultation.cellPhone}</td>
                        <td className="px-4 py-4 text-sm text-gray-700">{consultation.consultantName}</td>
                        <td className="px-4 py-4 text-sm text-gray-700">
                          <div className="flex items-center justify-center">
                            <FaEdit
                              className="text-blue-500 hover:text-blue-600 cursor-pointer w-5 h-5"
                              onClick={(e) => openEditModal(consultation)}
                            />
                          </div>
                        </td>
                      </tr>
                    )) : <tr>
                    <td colSpan="6" className="px-4 py-4 text-sm text-gray-700 text-center">
                      No data available
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <ModalBooked
          isOpen={isModalOpen}
          onClose={closeModal}
          consultation={selectedConsultation}
        />
      )}
      {isEditModalOpen && (
        <Modal2Booked  
          isOpen={isEditModalOpen}
          onClose={closeEditModal}
          consultation={editingConsultation}
          consultant={consultants}
          fetchConsultations={fetchConsultations}
          fetchConsultants={fetchConsultants}
        />
      )}
    </>
  );
}

export default Booked;